import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { TitleBar } from "../components/index.js";
import { getSoldiers } from "../logic/Logic.js";

const Play = ({}) => {
  const [infos, setInfos] = useState({});

  useEffect(() => {
    list();
  }, []);

  const sortSoldiers = (array) => {
    return array.sort((a, b) => {
      if (a.Soldier < b.Soldier) return -1;
      if (a.Soldier > b.Soldier) return 1;
      return 0;
    });
  };

  const list = async () => {
    const soldiers = getSoldiers();
    const specialists = soldiers.filter((obj) => obj.specialist === true);
    const normal = soldiers.filter((obj) => obj.specialist === false);
    const ret = { specialists: sortSoldiers(specialists), normal: sortSoldiers(normal), soldiers: sortSoldiers(soldiers) };
    setInfos(ret);
  };
  const table = (array = []) => {
    return (
      <table style={{ width: "100%" }}>
        <thead>
          <tr>
            <th>Soldier</th>
            <th>Move</th>
            <th>Fight</th>
            <th>Shoot</th>
            <th>Armour</th>
            <th>Will</th>
            <th>Health</th>
            <th>Cost</th>
            <th>Notes</th>
          </tr>
        </thead>
        <tbody>
          {array.map((obj) => {
            return (
              <tr>
                <td>{obj.Soldier}</td>
                <td>{obj.Move}</td>
                <td>{obj.Fight}</td>
                <td>{obj.Shoot}</td>
                <td>{obj.Armour}</td>
                <td>{obj.Will}</td>
                <td>{obj.Health}</td>
                <td>{obj.Cost}</td>
                <td>{obj.Notes}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  };

  return (
    <TitleBar marginLateral={15} showBack={false} titulo={"Play"}>
      <br></br>
      Normal
      {table(infos?.normal)}
      <br></br>
      <br></br>
      Specialists
      {table(infos?.specialists)}
      <br></br>
      <br></br>
      <br></br>
      {infos?.soldiers
        ?.filter((obj) => obj.description != null)
        .map((obj) => {
          return (
            <div>
              <label style={{ fontWeight: 900 }}>{obj.Soldier}: </label>
              {obj.description}
              <br></br>
              <br></br>
            </div>
          );
        })}
    </TitleBar>
  );
};

const mapStateToProps = (state) => ({
  user: state.Reducer.user,
});

const mapDispatchToProps = (dispatch) => ({});

export default compose(connect(mapStateToProps, mapDispatchToProps))(Play);
